<template>
  <div 
    class="break-normal whitespace-normal"
    :class="isBottom? 'disclaimer-bottom' : 'disclaimer my-4'"
  >
    <p>
      In submitting this order, 
      the individual ordering the test(s) for this patient confirms that 
      (1) s/he has a clinical relationship with this patient and submits this order 
      for purposes of diagnosis or treatment; 
      and (2) s/he is acting within his/her scope of practice 
      and is authorized under applicable state law to order the listed test(s) 
      for this patient.
      By clicking {{ buttonText }} above, 
      you agree for your card provided here to be charged the complete amount listed 
      to purchase testing according to 
      <DisclaimerHyperlink
        href="https://www.vibrant-wellness.com/TermsOfUse"
      >
        Terms of Use
      </DisclaimerHyperlink> 
      and 
      <DisclaimerHyperlink 
        href="https://vibrant-wellness.com/PrivacyPolicy"
      >
        Testing Policies
      </DisclaimerHyperlink>
      from Vibrant America and 
      <DisclaimerHyperlink 
        href="https://www.vibrant-wellness.com/TermsOfUse"
      >
        Terms of Use
      </DisclaimerHyperlink>
      from Vibrant Wellness.
    </p>
  </div>
</template>

<script>
import DisclaimerHyperlink from "./DisclaimerHyperlink.vue";
export default {
  components: {
    DisclaimerHyperlink
  },
  props: {
    buttonText: {
      type: String,
      default: ""
    }
  },
  computed: {
    isBottom() {
      return document.location.href.includes('/ordertest') 
        && !document.location.href.includes('order-center');
    }
  }
}
</script>

<style scoped>
.disclaimer {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.disclaimer-bottom {
  color: #000;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  margin-bottom: 24px;
  position: fixed;
  bottom: 0px; 
  left: 160px;
  right: 52px;
  height: 52px;
  overflow-y: auto; 
  z-index: 1001;

  padding-top: 10px;
  border-top: 1px solid rgba(201, 202, 205, var(--Step, 1));
}
</style>